import type { EventPropGetter, SlotGroupPropGetter, SlotPropGetter } from 'react-big-calendar';
import type { TourDuration } from '@zg-rentals/ts-z-calendar-client';
import { TourStatusForZcheduler } from '@zg-rentals/ts-z-calendar-client';
import { isBefore, transpose } from 'date-fns';
import { tz } from '@date-fns/tz';

import type { TimeZoneIds } from '../../constants/TourCalendar';
import { type TourEvent, Z_CALENDAR_EVENT_TYPE, type ZCalendarEvent } from '../../constants/TourCalendar';
import { generateClassNames } from '../../utils/classNameUtils';

export const eventStyleGetter: EventPropGetter<ZCalendarEvent> = (event) => {
  const isAvailabilityEvent = event.eventType === Z_CALENDAR_EVENT_TYPE.AVAILABILITY;
  const isTourEvent = event.eventType === Z_CALENDAR_EVENT_TYPE.TOUR;
  const isRequestedTour = isTourEvent && (event as TourEvent).tourStatus === TourStatusForZcheduler.REQUESTED;
  const isConfirmedTour = isTourEvent && (event as TourEvent).tourStatus === TourStatusForZcheduler.CONFIRMED;
  const isDeclinedTour = isTourEvent && (event as TourEvent).tourStatus === TourStatusForZcheduler.DECLINED;
  const isExpiredTour = isTourEvent && (event as TourEvent).tourStatus === TourStatusForZcheduler.EXPIRED;
  return {
    className: generateClassNames({
      'rbc-event-past-event': event.isPastEvent && !isExpiredTour,
      'rbc-event-availability-event': isAvailabilityEvent,
      'rbc-event-tour-event': isTourEvent,
      'rbc-event-tour-requested': isRequestedTour,
      'rbc-event-tour-confirmed': isConfirmedTour,
      'rbc-event-tour-declined': isDeclinedTour,
      'rbc-event-tour-expired': isExpiredTour,
    }),
  };
};

export const slotPropGetter: (now: Date, timeZone: TimeZoneIds) => SlotPropGetter =
  (now, timeZone) => (timeSlotDate) => {
    // Transpose timeSlotDate because timeslot dates are initially created in client's local timezone,
    // but need to be displayed in tour config timezone
    const timeSlotDateInTimeZone = transpose(timeSlotDate, tz(timeZone));
    const isPastTimeSlot = isBefore(timeSlotDateInTimeZone, now);
    return {
      className: isPastTimeSlot ? `rbc-slot-past` : '',
    };
  };

export const slotGroupPropGetter: (tourDuration: TourDuration) => SlotGroupPropGetter = (tourDuration) => () => {
  return {
    className: `rbc-timeslot-group rbc-timeslot-group-${tourDuration.toLowerCase()}`,
  };
};
